// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2752":"402bfcbc371beef3","2910":"03593822b38cfe03"}[chunkId] + ".css";
};